"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeCalculationServiceFactory = exports.TimeCalculationService = void 0;
var TimeCalculationService = /** @class */ (function () {
    function TimeCalculationService() {
    }
    /**
     * Normalizes a time value to a string in YYYY-MM-DDTHH:MM format
     */
    TimeCalculationService.normalizeTime = function (time) {
        if (!time)
            return null;
        if (time instanceof Date) {
            // Format Date object to local time string
            var year = time.getFullYear();
            var month = String(time.getMonth() + 1).padStart(2, '0');
            var day = String(time.getDate()).padStart(2, '0');
            var hours = String(time.getHours()).padStart(2, '0');
            var minutes = String(time.getMinutes()).padStart(2, '0');
            var result = "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hours, ":").concat(minutes);
            console.log('TimeCalculationService.normalizeTime', { input: time, result: result });
            return result;
        }
        if (typeof time === 'string') {
            console.log('TimeCalculationService.normalizeTime', { input: time, result: time });
            return time;
        }
        console.log('TimeCalculationService.normalizeTime', { input: time, result: null });
        return null;
    };
    /**
     * Checks if a unit is time-based (should use quantity for duration)
     */
    TimeCalculationService.isTimeBasedUnit = function (unit) {
        return !unit || unit === 'hours' || unit === 'time - hours';
    };
    /**
     * Calculates duration in hours between two times
     */
    TimeCalculationService.calculateDuration = function (startTime, endTime) {
        console.log('TimeCalculationService.calculateDuration called', { startTime: startTime, endTime: endTime });
        var startTimeStr = this.normalizeTime(startTime);
        var endTimeStr = this.normalizeTime(endTime);
        if (!startTimeStr || !endTimeStr) {
            console.log('TimeCalculationService.calculateDuration exiting early', { startTimeStr: startTimeStr, endTimeStr: endTimeStr });
            return null;
        }
        // Create Date objects to properly handle date differences
        var startDate = new Date(startTimeStr.replace('T', ' '));
        var endDate = new Date(endTimeStr.replace('T', ' '));
        // Validate that end time is after start time
        if (endDate.getTime() < startDate.getTime()) {
            console.log('TimeCalculationService.calculateDuration exiting early: end time is before start time', {
                startDate: startDate,
                endDate: endDate
            });
            return null;
        }
        var diffMs = endDate.getTime() - startDate.getTime();
        var diffHours = diffMs / (1000 * 60 * 60);
        // Round to nearest minute (4 decimal places for precision)
        var result = Math.round(diffHours * 10000) / 10000;
        console.log('TimeCalculationService.calculateDuration result', {
            startTimeStr: startTimeStr,
            endTimeStr: endTimeStr,
            startDate: startDate,
            endDate: endDate,
            diffMs: diffMs,
            diffHours: diffHours,
            result: result
        });
        return result;
    };
    /**
     * Calculates end time from start time and duration in hours
     */
    TimeCalculationService.calculateEndTime = function (startTime, durationHours) {
        console.log('TimeCalculationService.calculateEndTime called', { startTime: startTime, durationHours: durationHours });
        var startTimeStr = this.normalizeTime(startTime);
        if (!startTimeStr || durationHours === null || durationHours === undefined) {
            console.log('TimeCalculationService.calculateEndTime exiting early', { startTimeStr: startTimeStr, durationHours: durationHours });
            return null;
        }
        // Create Date object and add duration
        var startDate = new Date(startTimeStr.replace('T', ' '));
        var endDate = new Date(startDate.getTime() + durationHours * 60 * 60 * 1000);
        // Format back to datetime-local format
        var year = endDate.getFullYear();
        var month = String(endDate.getMonth() + 1).padStart(2, '0');
        var day = String(endDate.getDate()).padStart(2, '0');
        var hours = String(endDate.getHours()).padStart(2, '0');
        var minutes = String(endDate.getMinutes()).padStart(2, '0');
        var result = "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hours, ":").concat(minutes);
        console.log('TimeCalculationService.calculateEndTime result', {
            startTimeStr: startTimeStr,
            durationHours: durationHours,
            startDate: startDate,
            endDate: endDate,
            result: result
        });
        return result;
    };
    /**
     * Calculates end time from start time and quantity (for time-based units)
     */
    TimeCalculationService.calculateEndTimeFromQuantity = function (startTime, quantity) {
        return this.calculateEndTime(startTime, quantity);
    };
    /**
     * Adds minutes to a duration in hours, returning the new duration in hours
     * Uses minute-based arithmetic to avoid floating-point precision issues
     */
    TimeCalculationService.addMinutesToDuration = function (currentHours, minutesToAdd) {
        var currentMinutes = currentHours * 60;
        var newMinutes = currentMinutes + minutesToAdd;
        return Math.max(0, newMinutes / 60);
    };
    /**
     * Sets duration from minutes, returning hours
     */
    TimeCalculationService.durationFromMinutes = function (minutes) {
        return Math.max(0, minutes / 60);
    };
    return TimeCalculationService;
}());
exports.TimeCalculationService = TimeCalculationService;
// AngularJS service factory
function timeCalculationServiceFactory() {
    return {
        normalizeTime: TimeCalculationService.normalizeTime.bind(TimeCalculationService),
        isTimeBasedUnit: TimeCalculationService.isTimeBasedUnit.bind(TimeCalculationService),
        calculateDuration: TimeCalculationService.calculateDuration.bind(TimeCalculationService),
        calculateEndTime: TimeCalculationService.calculateEndTime.bind(TimeCalculationService),
        calculateEndTimeFromQuantity: TimeCalculationService.calculateEndTimeFromQuantity.bind(TimeCalculationService),
        addMinutesToDuration: TimeCalculationService.addMinutesToDuration.bind(TimeCalculationService),
        durationFromMinutes: TimeCalculationService.durationFromMinutes.bind(TimeCalculationService)
    };
}
exports.timeCalculationServiceFactory = timeCalculationServiceFactory;
